import { motion } from 'framer-motion';
import { Calendar, Clock } from 'lucide-react';
import { formatDateToShort, formatTimeToDisplay } from '@/utils/dateUtils';

interface EventDisplayProps {
  event: {
    id: string;
    date: string;
    time: string;
  };
}

export function EventDisplay({ event }: EventDisplayProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="card mb-6"
    >
      <div className="space-y-2 text-sm">
        <div className="flex items-center space-x-2">
          <Calendar className="w-4 h-4 text-primary-800 dark:text-primary-600" />
          <span className="font-medium dark:text-neutral-100">
            {formatDateToShort(event.date)}
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Clock className="w-4 h-4 text-primary-800 dark:text-primary-600" />
          <span className="dark:text-neutral-200">{formatTimeToDisplay(event.time)}</span>
        </div>
      </div>
    </motion.div>
  );
}

